import { Typography } from '@mui/material';
import CurrencyFormatter from '@apigrowfinance/pbolt-currency-formatter';
import { Panel } from '@apigrowfinance/pbolt-panel';
import { RiCoinLine, RiLineChartLine, RiPieChart2Line } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';

import { LimitsDetails } from '@clients/accountsClient';
import DividerPanel from '@components/overviewPanels/dividerPanel/DividerPanel';
import LimitTile from '@pages/limits/LimitTile';

interface LimitOverviewPanelProps {
    currencyCode: string;
    limits: LimitsDetails;
    isLoading: boolean;
}

const LimitOverviewPanel = ({
    currencyCode,
    limits,
    isLoading,
}: LimitOverviewPanelProps) => {
    return (
        <Panel>
            <DividerPanel isLoading={isLoading} isClickable={false}>
                <LimitTile
                    isLoading={isLoading}
                    icon={<RiCoinLine />}
                    value={
                        <CurrencyFormatter
                            currency={currencyCode}
                            amount={limits?.max_credit_limit}
                        />
                    }
                    title={
                        <Typography variant="overline">
                            <FormattedMessage
                                id="Limits.maxCreditLimit"
                                defaultMessage="Max credit limit"
                            />
                        </Typography>
                    }
                />
                <LimitTile
                    isLoading={isLoading}
                    icon={<RiPieChart2Line />}
                    value={
                        <CurrencyFormatter
                            currency={currencyCode}
                            amount={limits?.total_overdraft_limit}
                        />
                    }
                    title={
                        <Typography variant="overline">
                            <FormattedMessage
                                id="Limits.totalOverdraftLimit"
                                defaultMessage="Total overdraft limit"
                            />
                        </Typography>
                    }
                />
                <LimitTile
                    isLoading={isLoading}
                    icon={<RiLineChartLine />}
                    value={`${limits?.percentage_over_limit}%`}
                    title={
                        <Typography variant="overline">
                            <FormattedMessage
                                id="Limits.percentageOverLimit"
                                defaultMessage="Percentage over limit"
                            />
                        </Typography>
                    }
                />
            </DividerPanel>
        </Panel>
    );
};

export default LimitOverviewPanel;
